import 'dayjs/locale/de';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import type { Dates as DateType } from 'types/capi/shared';

import type { Region } from './region';
import { DEFAULT_REGION } from './region';

dayjs.extend(utc);
dayjs.extend(timezone);

export function getCurrentDateUnix() {
  return Math.floor(Date.now() / 1000);
}

export function formatReleaseDateShort(
  unixTimestamp: number,
  region: Region = DEFAULT_REGION
) {
  return dayjs(unixTimestamp * 1000)
    .tz(region.timeZone)
    .locale(region.lang)
    .format('ddd DD MMM');
}

export function formatReleaseDate(
  unixTimestamp: number,
  region: Region = DEFAULT_REGION
) {
  return dayjs(unixTimestamp * 1000)
    .tz(region.timeZone)
    .locale(region.lang)
    .format('ddd DD MMM YY');
}

export function formatReleaseDateLong(
  unixTimestamp: number,
  region: Region = DEFAULT_REGION
) {
  return dayjs(unixTimestamp * 1000)
    .tz(region.timeZone)
    .locale(region.lang)
    .format('ddd DD MMM YY hh:mm A');
}

export function formatRaffleDate(
  unixTimestamp: number,
  region: Region = DEFAULT_REGION
) {
  return dayjs(unixTimestamp * 1000)
    .tz(region.timeZone)
    .locale(region.lang)
    .format('D MMM ha');
}

export const formatReleaseDateLarge = (
  unixTimestamp: number,
  region: Region = DEFAULT_REGION
) => {
  let ts = unixTimestamp * 1000;

  return (
    dayjs(ts).tz(region.timeZone).locale(region.lang).format('ddd DD MMM') +
    ' at ' +
    dayjs(ts)
      .tz(region.timeZone)
      .locale(region.lang)
      .format('hh:mm a')
      .toUpperCase()
  );
};

export function formatArticleDate(
  { date }: { date: DateType },
  region: Region = DEFAULT_REGION
) {
  return dayjs(Number(`${date.modified ?? date.published}`) * 1000)
    .tz(region.timeZone)
    .locale(region.lang)
    .format('DD MMM, YYYY h:mm A');
}

export function formatFeatureDate(
  unixTimestamp: number,
  region: Region = DEFAULT_REGION
) {
  return dayjs(unixTimestamp * 1000)
    .tz(region.timeZone)
    .locale(region.lang)
    .format('DD MMM YYYY');
}
